export const SET_PRODUCTS = "my_lists/SET_PRODUCTS";

export const SET_SELECTED_FAVORITOS_LIST = "my_lists/SET_SELECTED_FAVORITOS_LIST";

export const SET_SELECTED_FAVORITE_PRODUCTS_PAGINATION = "my_lists/SET_SELECTED_FAVORITE_PRODUCTS_PAGINATION";

export const SET_CURRENT_PAGE_FAVORITE_PRODUCTS_SELECTED = "my_lists/SET_CURRENT_PAGE_FAVORITE_PRODUCTS_SELECTED"

export const SET_IS_ADDING_PRODUCT_TO_FAVORITES = "my_lists/SET_IS_ADDING_PRODUCT_TO_FAVORITES"

export const SET_RESEARCHING_PRODUCT = "my_lists/SET_RESEARCHING_PRODUCT"

export const SET_FETCHING_FILTERS = "my_lists/SET_FETCHING_FILTERS"

export const SET_FILTERS = "my_lists/SET_FILTERS";

export const SET_SELECTED_FILTERS = "my_lists/SET_SELECTED_FILTERS";

export const SET_SEARCH_TEXT = "my_lists/SET_TEXT_SEARCH"

export const SET_PARENTS_ID = "my_lists/SET_PARENTS_ID"

export const SET_INFLUENCER_ID = "my_lists/SET_INFLUENCER_ID"

export const SET_FILTER_LIKES = "my_lists/SET_FILTER_LIKES"

export const SET_FILTER_KEYS = "my_lists/SET_FILTER_KEYS"

export const SET_PRICE_RANGE = "my_lists/SET_PRICE_RANGE"

export const SET_PARTNER_LANDING_LINK = "my_lists/SET_PARTNER_LANDING_LINK"

export const SET_ORDER_BY = "my_lists/SET_ORDER_BY"

export const SET_PAYLOAD_PRODUCTS = "my_lists/SET_PAYLOAD_PRODUCTS"

export const SET_LOADING = "my_lists/SET_LOADING"

export const SET_LOADING_ADDING_ONE_PRODUCT = "my_lists/SET_LOADING_ADDING_ONE_PRODUCT"

export const SET_CURRENT_PAGE = "my_lists/SET_CURRENT_PAGE"

export const SET_SELECTED_ALL_PRODUCTS = "my_lists/SET_SELECTED_ALL_PRODUCTS"

export const SET_DRAWER = "my_lists/SET_DRAWER"

export const SET_ALL_COMPANIES_IN_CENTRALIZED = "my_lists/SET_ALL_COMPANIES_IN_CENTRALIZED"

export const SET_DASHBOARD_CENTRALIZED = "my_lists/SET_DASHBOARD_CENTRALIZED"

export const SET_COMPANIES_IDS_IN_CENTRALIZED = "my_lists/SET_COMPANIES_IDS_IN_CENTRALIZED"

export const SET_PARENT_ID_FETCH_FILTERS = "my_lists/SET_PARENT_ID_FETCH_FILTERS"

export const SET_COMPANIES_FILTER_IN_CENTRALIZED = "my_lists/SET_COMPANIES_FILTER_IN_CENTRALIZED"

export const SET_REQUEST_CONFIG_IN_CENTRALIZED = "my_lists/SET_REQUEST_CONFIG_IN_CENTRALIZED"

export const SET_LOADING_IN_SELECTED_FAVORITES_LIST = "my_lists/SET_LOADING_IN_SELECTED_FAVORITES_LIST"

export const SET_COMPANIES_IDS_IN_SELECTED_FAVORITES_LIST = "my_lists/SET_COMPANIES_IDS_IN_SELECTED_FAVORITES_LIST"